import React, { Component } from 'react';
import './NavigationYear.css';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';



class NavigationYear extends Component {


	render() {

		let linkAddition = this.props.region ? 'schulferien/' + this.props.region + '/' : '';
		let prevYear = '';
		let nextYear = '';

		let yearStart = this.props.yearStart ? this.props.yearStart : (new Date().getFullYear())-3;
		let yearEnd = this.props.yearEnd ? this.props.yearEnd : (new Date().getFullYear())+5;

		if(this.props.isGenerator) {
			linkAddition = 'zum-ausdrucken/';
		}
		if(this.props.year > yearStart) {
			prevYear = <Link to={'/' + (this.props.year-1) + '/' + linkAddition} className="arrow left" onClick={this.props.onDecrement}>Zurück</Link>
		}

		if(this.props.year < yearEnd) {
			nextYear = <Link to={'/' + (this.props.year+1) + '/' + linkAddition} className="arrow right" onClick={this.props.onIncrement}>Weiter</Link>
		}

		return (
			<div className="NavigationYear">
				<div className="NavigationYear-content">

					{prevYear}
					<span className="current-year">{this.props.year}</span>
					{nextYear}
				</div>

			</div>
		);
	}
}


NavigationYear.propTypes = {
	year: PropTypes.number.isRequired,
	region: PropTypes.string,
	onDecrement: PropTypes.number,
	onIncrement: PropTypes.number
}

export default NavigationYear;



// WEBPACK FOOTER //
// ./src/components/NavigationYear.js